import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight, Linkedin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t mt-0"
      style={{ borderColor: "var(--border-subtle)", background: "var(--bg-soft)" }}
    >
      <div className="container-x pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <span className="overline">— Global Investment Capital Partners</span>
            <h3 className="font-serif text-4xl md:text-6xl mt-4 leading-[0.95] tracking-tight">
              Capital that <em className="italic" style={{ color: "var(--gicp-gold)" }}>builds</em><br/>
              the continent.
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="btn-gold mt-8"
            >
              Start a conversation <ArrowUpRight size={16} />
            </Link>
          </div>

          <div className="md:col-span-3">
            <span className="overline">Office</span>
            <ul className="mt-5 space-y-3 text-sm" style={{ color: "var(--fg-soft)" }}>
              <li className="flex items-start gap-3">
                <MapPin size={14} className="mt-1" style={{ color: "var(--gicp-gold)" }} />
                <span>1 Amand Avenue, Menlyn Maine,<br/>Pretoria, 0181, South Africa</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={14} className="mt-1" style={{ color: "var(--gicp-gold)" }} />
                <a href="mailto:investor@gicp.co.za" className="hover:text-[var(--gicp-gold)]">
                  investor@gicp.co.za
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={14} className="mt-1" style={{ color: "var(--gicp-gold)" }} />
                <a href="tel:+27630206195" className="hover:text-[var(--gicp-gold)]" data-testid="footer-phone">
                  +27 63 020 6195
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Linkedin size={14} className="mt-1" style={{ color: "var(--gicp-gold)" }} />
                <a
                  href="https://za.linkedin.com/in/simon-teffo-5686b31b3"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[var(--gicp-gold)]"
                  data-testid="footer-linkedin"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="overline">Navigate</span>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" className="hover:text-[var(--gicp-gold)]">Home</Link></li>
              <li><Link to="/about" className="hover:text-[var(--gicp-gold)]">About</Link></li>
              <li><Link to="/services" className="hover:text-[var(--gicp-gold)]">Services</Link></li>
              <li><Link to="/contact" className="hover:text-[var(--gicp-gold)]">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div
          className="mt-16 pt-8 border-t flex flex-col md:flex-row gap-4 md:items-center md:justify-between"
          style={{ borderColor: "var(--border-subtle)" }}
        >
          <p className="text-xs tracking-[0.2em] uppercase" style={{ color: "var(--fg-soft)" }}>
            © {new Date().getFullYear()} GICP — All Rights Reserved
          </p>
          <p className="text-xs tracking-[0.2em] uppercase" style={{ color: "var(--fg-soft)" }}>
            Corporate Finance · Investment Holding · Strategic Partnerships
          </p>
        </div>
      </div>
    </footer>
  );
}
